<template>
  <el-menu
    :default-active="activeMenu"
    mode="horizontal"
    background-color="#84226D"
    text-color="rgba(255,255,255,0.85)"
    active-text-color="#ffffff"
    class="app-header-menu"
  >
    <!-- Not logged in: only language switcher -->
    <template v-if="!isLoggedIn">
      <el-menu-item index="language">
        <LanguageSwitcher />
      </el-menu-item>
    </template>

    <!-- Logged in: full nav -->
    <template v-else>
      <el-menu-item index="/position" @click="navigate('/position')">
        {{ $t('position details') }}
      </el-menu-item>
      <el-menu-item index="/product" @click="navigate('/product')">
        {{ $t('product') }}
      </el-menu-item>
      <el-menu-item index="/resource" @click="navigate('/resource')">
        {{ $t('resource') }}
      </el-menu-item>
      <el-submenu index="me">
        <template slot="title">{{ $t('me') }}</template>
        <el-menu-item index="/me" @click="navigate('/me')">{{ $t('user profile') }}</el-menu-item>
        <el-menu-item index="/change-password" @click="showChangePassword">{{ $t('change password') }}</el-menu-item>
        <el-menu-item index="/logout" @click="handleLogout">{{ $t('logout') }}</el-menu-item>
      </el-submenu>
    </template>
  </el-menu>
</template>

<script>
import LanguageSwitcher from './LanguageSwitcher.vue'
import { eventBus } from '@/router'

export default {
  name: 'AppHeader',
  components: { LanguageSwitcher },
  computed: {
    isLoggedIn() {
      return !!this.$store.state.auth.token
    },
    activeMenu() {
      const path = this.$route.path
      if (['/product', '/resource', '/position'].includes(path)) return path
      if (['/profile/ins', '/profile/ind'].includes(path)) return '/me'
      return ''
    }
  },
  methods: {
    navigate(path) {
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
    },
    showChangePassword() {
      eventBus.$emit('show-change-password-dialog', { forced: false })
    },
    handleLogout() {
      this.$store.dispatch('auth/logout')
      // this.$router.replace('/login')
    }
  }
}
</script>

<style scoped>
.app-header-menu {
  background-color: transparent !important;
  border-bottom: none !important;
  float: right;
}
.app-header-menu >>> .el-menu-item.is-active {
  color: #ffffff !important;
  border-bottom: none !important;
}
.app-header-menu >>> .el-menu-item.is-active::after {
  border-bottom: none !important;
}
@media screen and (max-width: 768px) {
  .app-header-menu {
    float: none !important;
    width: 100%;
  }
  .app-header-menu >>> .el-menu-item,
  .app-header-menu >>> .el-submenu__title {
    padding: 0 12px !important;
    font-size: 13px !important;
  }
}
@media screen and (max-width: 576px) {
  .app-header-menu >>> .el-menu-item,
  .app-header-menu >>> .el-submenu__title {
    padding: 0 8px !important;
    font-size: 12px !important;
  }
}
</style>
